// extracted by mini-css-extract-plugin
export default {"card":"skills-assigned-widget_card__eJ20V","skillCount":"skills-assigned-widget_skillCount__FuCER"};